import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4 w-full max-w-3xl mx-auto" data-id="element-99">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-100">
            <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-101">
              <span className="font-heading font-bold text-brand-gray-dark pr-4" data-id="element-102">
                {item.question}
              </span>
              <span className="text-brand-blue flex-shrink-0" data-id="element-103">
                {isOpen ? <Minus size={20} data-id="element-104" /> : <Plus size={20} data-id="element-105" />}
              </span>
            </button>
            <AnimatePresence initial={false} data-id="element-106">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-107">
                  <div className="p-5 pt-0 text-brand-gray font-body leading-relaxed border-t border-gray-100" data-id="element-108">
                    {item.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}